class HTMLCanvasInteractiveObjectService {
    constructor() {
        this.interactiveObjects = [];
        this.objects = new Map();
        this.renderables = new Map();
    }
    getElement(obj) {
        const data = this.objects.get(obj);
        if (!data)
            return;
        return data.element;
    }
    getObjectData(obj) {
        return this.objects.get(obj);
    }
    addInteractiveObject(obj, element, renderable) {
        if (this.objects.has(obj))
            return;
        const index = this.interactiveObjects.length;
        this.interactiveObjects.push(obj);
        this.objects.set(obj, {
            index,
            element,
            renderable
        });
    }
    removeInteractiveObject(obj) {
        const objData = this.objects.get(obj);
        if (objData === undefined)
            return;
        this.objects.delete(obj);
        const lastObject = this.interactiveObjects.pop();
        if (!lastObject)
            return;
        if (objData.index >= this.interactiveObjects.length)
            return;
        const lastObjData = this.objects.get(obj);
        if (lastObjData) {
            lastObjData.index = objData.index;
        }
        this.interactiveObjects[objData.index] = lastObject;
    }
    addRenderable(renderable, obj, element) {
        this.removeRenderable(renderable);
        this.addInteractiveObject(obj, element, renderable);
        this.renderables.set(renderable, {
            obj
        });
    }
    removeRenderable(renderable) {
        const data = this.renderables.get(renderable);
        if (!data)
            return;
        this.renderables.delete(renderable);
        this.removeInteractiveObject(data.obj);
    }
}
export const htmlCanvasInteractiveObjectService = new HTMLCanvasInteractiveObjectService();
